import React, { useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import {
    PageWrapper,
    Flex,
    H1WithBack,
} from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import useQueryPagination from 'hooks/useQueryPagination'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { dietaryPreferences } from '../foodData'
import { days } from 'pages/Employees/employeesData'
import { AddSelectedDishModal, ISelectedDish } from './AddSelectedDishModal'
import { clearSelectedDishes, getSelectedDishes } from 'features/food/foodSlice'
import { IGetSelectedDishesReponse } from 'types/api/foodApi.interface'

export const SelectedDishes = () => {
    const { selectedDishes } = useSelector((store: RootState) => store.food)
    const [modal, setModal] = useState(false)

    const transformDataForModal = (dishes: IGetSelectedDishesReponse): ISelectedDish[] => {
        return dishes.dishes.map(d => ({
            id: d.id,
            day: days.find(day => day.value == d.dayInWeek),
            dietaryPreference: dietaryPreferences.find(p => p.value == d.dietaryPreferenceType),
            mealType: { value: d.mealType.id, label: d.mealType.name },
            dish: { value: d.dish.id, label: d.dish.name },
            supplier: { value: d.supplier.id, label: d.supplier.name },
        }))
    }

    // id: number
    // day: ISelectValue
    // dietaryPreference: ISelectValue
    // mealType: ISelectValue
    // dish: ISelectValue
    // supplier: ISelectValue

    useQueryPagination({ fetchFunctions: [getSelectedDishes], cleanUpFunctions: [clearSelectedDishes], params: null })

    const columns: IHonestTableColumn<any>[] = [
        { id: 'day', header: 'Day', cell: (item) => days.find(d => d.value == item.dayInWeek).label },
        { id: 'mealType', header: 'Meal Type', cell: (item) => item.mealType?.name },
        { id: 'dish', header: 'Dish', cell: (item) => item.dish?.name },
        { id: 'supplier', header: 'Supplier', cell: (item) => item.supplier?.name },
        { id: 'dietaryPreference', header: 'Dietary Preference', cell: (item) => dietaryPreferences.find(p => p.value == item.dietaryPreferenceType).label },
    ]

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between center>
                    <H1WithBack title='Selected Dishes' arrow />
                    <Button variant='primary' onClick={() => setModal(true)}>
                        Add Dish
                    </Button>
                </Flex>
                {!selectedDishes?.dishes?.length ? (
                    <NoItems marginTop='1rem' title='Dishes' />
                ) : (
                    <HonestTable columns={columns} data={selectedDishes.dishes} keyField='id' />
                )}
                {modal && <AddSelectedDishModal data={transformDataForModal(selectedDishes)} closeModal={() => setModal(false)} />}
            </PageWrapper>

        </>
    )
}
